import React from 'react';
import NoAssetsScreen from '../../pages/errorPages/NoAssets';
import Accordion from '../common/Accordion';
import AccordionHeader from './AccordionHeader';
import ResourceList from './ResourceList';
interface AccordionListProps {
    all_videos: boolean;
    data: any;
    bookId: any;
}
const AccordionList: React.FC<AccordionListProps> = ({
    all_videos,
    data,
    bookId,
}) => {
    const [openId, setOpenId] = React.useState<number | null>(null);

    const toggleOpen = (id: number) => {
        setOpenId(openId === id ? null : id);
    };
    return (
        <div className="pb-8 overflow-scroll custom-scrollbar">
            {!data || data.length === 0 ? (
                <NoAssetsScreen />
            ) : (
                data.map((item: any, index: number) => (
                    <Accordion
                        key={item.unitid}
                        index={index}
                        id={item.unitid}
                        isOpen={openId === item.unitid}
                        toggleOpen={toggleOpen}
                        header={<AccordionHeader item={item} />}
                        content={
                            <ResourceList
                                all_videos={all_videos}
                                usm_id={item.usmid}
                                first_page={item?.firstPage}
                                last_page={item?.lastPage}
                                book_name={item?.bookName}
                                bookId={bookId}
                            />
                        }
                    />
                ))
            )}
        </div>
    );
};

export default AccordionList;
